export default "__VITE_ASSET__F3xPc0Jb__"